import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { links } from './links';

// Ported from the marketing site Navbar. The "Blogs" link is intentionally
// removed so the in-app home doesn't confuse users with the marketing blog.
const navLinks = [
  { href: '#features', label: 'Features', internal: false },
  { href: '#how-it-works', label: 'How It Works', internal: false },
  { href: '#faq', label: 'FAQ', internal: false },
  { href: links.contact, label: 'Contact', internal: true },
];

const NavItem = ({ link, className, onClick }) => {
  if (link.external) {
    return (
      <a href={link.href} className={className} onClick={onClick}>
        {link.label}
      </a>
    );
  }
  if (link.internal) {
    return (
      <Link to={link.href} className={className} onClick={onClick}>
        {link.label}
      </Link>
    );
  }
  // In-page anchor
  return (
    <a href={link.href} className={className} onClick={onClick}>
      {link.label}
    </a>
  );
};

const LandingNavbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const closeMenu = () => setIsMobileMenuOpen(false);

  return (
    <>
      <nav className={`cf-nav${isScrolled ? ' cf-nav--scrolled' : ''}`}>
        <div className="cf-container">
          <div className="cf-nav__bar">
            <Link to={links.home} className="cf-nav__logo">
              <img src="/Image/CricFight_Logo.png" alt="CricFight Logo" />
              <span className="cf-nav__brand">
                Cric<span className="cf-text-gradient">Fight</span>
              </span>
            </Link>

            <div className="cf-nav__links">
              {navLinks.map((link) => (
                <NavItem key={link.label} link={link} className="cf-nav__link" />
              ))}
            </div>

            <div className="cf-nav__ctas">
              <Link to={links.startMatch} className="cf-btn-secondary">Start a Match</Link>
              <Link to={links.login} className="cf-btn-primary cf-nav__cta-primary">Start for Free</Link>
            </div>

            <div className="cf-nav__mobile">
              <button
                className={`cf-hamburger${isMobileMenuOpen ? ' is-open' : ''}`}
                onClick={() => setIsMobileMenuOpen((v) => !v)}
                aria-label="Toggle menu"
              >
                <span />
                <span />
                <span />
              </button>
            </div>
          </div>
        </div>
      </nav>

      <div className={`cf-mobile-menu${isMobileMenuOpen ? ' is-open' : ''}`}>
        <div className="cf-mobile-menu__panel">
          <nav className="cf-mobile-menu__nav">
            {navLinks.map((link) => (
              <NavItem key={link.label} link={link} className="cf-mobile-menu__link" onClick={closeMenu} />
            ))}
          </nav>
          <div className="cf-mobile-menu__ctas">
            <Link to={links.login} className="cf-btn-primary cf-btn-block" onClick={closeMenu}>Start for Free</Link>
            <Link to={links.startMatch} className="cf-btn-secondary cf-btn-block" onClick={closeMenu}>Start a Match</Link>
          </div>
          <p className="cf-mobile-menu__foot">100% free · no ads · setup in 2 min</p>
        </div>
      </div>
    </>
  );
};

export default LandingNavbar;
